import {
  useDataChange,
  useDataIsSubmitting,
  useDataValue,
} from 'Simple/Data.js'
import { normalizePath, useFlow } from 'Simple/Flow.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return function onClick(value) {
    change(next => {
      next.selected_rows = null
      if (next.merged?.url) {
        try {
          URL.revokeObjectURL(next.merged.url)
        } catch (_) {}
      }
      next.merged = null
      next.query = {
        version: Date.now(),
        location_ids: next.location_ids,
        due_buckets: next.due_buckets,
        min_due_now_amount: next.min_due_now_amount,
      }
    })
  }
}

export function useIsDisabled(props) {
  let isSubmitting = useDataIsSubmitting({
    context: 'selected',
    viewPath: props.viewPath,
  })
  let flow = useFlow()
  let value = useDataValue({
    viewPath: props.viewPath,
    context: 'selected',
  })

  return (
    value.due_buckets.length === 0 ||
    value.location_ids.length === 0 ||
    value.credit_cards.length === 0 ||
    isNaN(value.min_due_now_amount) ||
    value.min_due_now_amount < 0.01 ||
    isSubmitting ||
    flow.has(normalizePath(props.viewPath, '../Data/Loading'))
  )
}
